import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/*  GÉPJÁRMŰ – a kiszolgáló által összeállított nyomtatható lapok (útnyilvántartás, kiküldetési rendelvény)
 *  nyomtatása. Ugyanaz a megoldás, mint a Bér iratainál (ber/adatszolg/dokumentum-nyomtatas.ts): nem a
 *  képernyőt nyomtatjuk, hanem egy rejtett keretbe írt tiszta HTML-dokumentumot – a lap tokennel jön
 *  (a /api/ címek token nélkül nem adnak ki fájlt), ezért nem nyitható meg egyszerű linkként. */
export async function gjLapNyomtat(http: HttpClient, utvonal: string, fekvo = false): Promise<void> {
  const html = await firstValueFrom(http.get(`/api/gepjarmu-ut${utvonal}`, { responseType: 'text' }));
  const keret = document.createElement('iframe');
  keret.setAttribute('aria-hidden', 'true');
  //  A keret szélessége a lap nyomtatható szélessége – a Firefox ezzel tördel.
  keret.style.cssText = `position:fixed;left:-10000px;top:0;width:${fekvo ? '273mm' : '186mm'};height:${fekvo ? '186mm' : '273mm'};border:0;visibility:hidden`;
  document.body.appendChild(keret);
  const doc = keret.contentDocument!;
  doc.open(); doc.write(html); doc.close();
  const takarit = () => setTimeout(() => keret.remove(), 1000);
  keret.contentWindow!.addEventListener('afterprint', takarit);
  await new Promise<void>((ok) => setTimeout(() => {
    try { keret.contentWindow!.focus(); keret.contentWindow!.print(); } finally { setTimeout(takarit, 60000); ok(); }
  }, 250));
}

export const HONAPOK = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];
export const JELLEG_NEV: Record<string, string> = { uzleti: 'üzleti', magan: 'magán', munkaba: 'munkába' };
export const fmt = (v: any, t = 0): string => (v == null || v === '' || !Number.isFinite(Number(v)) ? '' : Number(v).toLocaleString('hu-HU', { minimumFractionDigits: t, maximumFractionDigits: t }));
export const fmtMax = (v: any, t = 2): string => (v == null || v === '' || !Number.isFinite(Number(v)) ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: t }));
export const huDatum = (d: any): string => (d ? String(d).slice(0, 10).replace(/-/g, '. ') + '.' : '');
export const hibaSzoveg = (e: any, alap: string): string => e?.error?.error || (typeof e?.error === 'string' && e.error.startsWith('{') ? (() => { try { return JSON.parse(e.error).error; } catch { return null; } })() : null) || alap;
